import kingston_september from './files/September/Kingston.pdf';
import cardinal_september from './files/September/Cardinal.pdf';
import woking_september from './files/September/Woking.pdf';
import richmond_september from './files/September/Richmond.pdf';
import tunbridge_september from './files/September/Tunbridge.pdf';
import wilberforce_september from './files/September/Wilberforce.pdf';
import holland_september from './files/September/Holland Park.pdf';

import kingston_november from './files/November/Kingston November.pdf';
import cardinal_november from './files/November/Cardinal November.pdf';
import woking_november from './files/November/Woking November .pdf';
import richmond_november from './files/November/Richmond November .pdf';
import tunbridge_november from './files/November/Tunbridge November.pdf';
import wilberforce_november from './files/November/Willbeforce November.pdf';
import holland_november from './files/November/Holland Park November .pdf';
import hillingdon_november from './files/November/Hillingdon November.pdf';
import { DROPBOX_BROCHURE_MANIFEST } from './dropboxBrochuresManifest';

const buildBrochure = (month, monthUa, schoolName, schoolNameUa, pdf) => ({
  month,
  monthUa,
  title: `${schoolName} ${month}`,
  titleUa: `${schoolNameUa || schoolName} ${monthUa || month}`,
  sharedUrl: pdf,
  previewUrl: pdf,
  downloadUrl: pdf,
});

const CURRENT_YEAR = '2025-2026';
const PREVIOUS_YEAR = '2024-2025';

const MONTH_UA = {
  September: 'Вересень',
  October: 'Жовтень',
  November: 'Листопад',
  December: 'Грудень',
  January: 'Січень',
  February: 'Лютий',
  March: 'Березень',
  'September-October': 'Вересень-Жовтень',
  'November-December': 'Листопад-Грудень',
  'December-January': 'Грудень-Січень',
};

const SCHOOL_DISPLAY_NAME = {
  amersham: { en: 'Amersham', ua: 'Amersham' },
  cardinal: { en: 'Cardinal Vaughan', ua: 'Cardinal Vaughan' },
  glasgow: { en: 'Glasgow', ua: 'Glasgow' },
  guildford: { en: 'Guildford', ua: 'Guildford' },
  hillingdon: { en: 'Hillingdon', ua: 'Hillingdon' },
  holland: { en: 'Holland Park', ua: 'Holland Park' },
  kingston: { en: 'Kingston', ua: 'Kingston' },
  merton: { en: 'Merton', ua: 'Merton' },
  northampton: { en: 'Northampton', ua: 'Northampton' },
  nursery: { en: 'Tadpoles Nursery', ua: 'Tadpoles Nursery' },
  richmond: { en: 'Richmond', ua: 'Richmond' },
  stratford: { en: 'Stratford', ua: 'Stratford' },
  tunbridge: { en: 'Tunbridge Wells', ua: 'Tunbridge Wells' },
  wilberforce: { en: 'Wilberforce', ua: 'Wilberforce' },
  woking: { en: 'Woking', ua: 'Woking' },
};

export const SCHOOL_FOLDER_ALIAS_MAP = {
  amersham: ['amersham'],
  cardinal: ['cardinal', 'cardinalvaughan'],
  glasgow: ['glasgow'],
  guildford: ['guildford'],
  hillingdon: ['hillingdon'],
  holland: ['holland', 'hollandpark'],
  kingston: ['kingston'],
  merton: ['merton'],
  northampton: ['northampton'],
  nursery: ['nursery', 'tadpoles', 'tadpolesnursery'],
  richmond: ['richmond'],
  stratford: ['stratford'],
  tunbridge: ['tunbridge', 'tunbridgewells'],
  wilberforce: ['wilberforce'],
  woking: ['woking'],
};

const normalizeAlias = (value = '') => value.toLowerCase().replace(/[^a-z0-9]/g, '');

const resolveSchoolByFolder = (folderName) => {
  const normalizedFolderName = normalizeAlias(folderName);

  return (
    Object.entries(SCHOOL_FOLDER_ALIAS_MAP).find(([, aliases]) =>
      aliases.some((alias) => normalizeAlias(alias) === normalizedFolderName)
    )?.[0] || null
  );
};

export const toDropboxPdfLinks = (sharedUrl) => {
  const shared = new URL(sharedUrl);
  shared.searchParams.set('dl', '0');
  shared.searchParams.delete('raw');

  const preview = new URL(shared.toString());
  preview.searchParams.delete('dl');
  preview.searchParams.set('raw', '1');

  const download = new URL(shared.toString());
  download.searchParams.delete('raw');
  download.searchParams.set('dl', '1');

  return {
    sharedUrl: shared.toString(),
    previewUrl: preview.toString(),
    downloadUrl: download.toString(),
  };
};

const inferBrochureMonth = (fileName) => {
  const normalizedName = normalizeAlias(fileName);

  if (normalizedName.includes('septemberoctober')) return 'September-October';
  if (normalizedName.includes('novemberdecember')) return 'November-December';
  if (normalizedName.includes('decemberjanuary') || normalizedName.includes('decemberandjanuary')) {
    return 'December-January';
  }
  if (normalizedName.includes('september')) return 'September';
  if (normalizedName.includes('october')) return 'October';
  if (normalizedName.includes('november')) return 'November';
  if (normalizedName.includes('december')) return 'December';
  if (normalizedName.includes('january')) return 'January';
  if (normalizedName.includes('february')) return 'February';
  if (normalizedName.includes('march')) return 'March';

  return '';
};

const buildDropboxBrochure = (schoolSlug, fileName, sharedUrl) => {
  const schoolName = SCHOOL_DISPLAY_NAME[schoolSlug]?.en || schoolSlug;
  const schoolNameUa = SCHOOL_DISPLAY_NAME[schoolSlug]?.ua || schoolName;
  const month = inferBrochureMonth(fileName);
  const monthUa = MONTH_UA[month] || month;
  const links = toDropboxPdfLinks(sharedUrl);

  return {
    month,
    monthUa,
    title: month ? `${schoolName} ${month}` : fileName,
    titleUa: month ? `${schoolNameUa} ${monthUa}` : fileName,
    sharedUrl: links.sharedUrl,
    previewUrl: links.previewUrl,
    downloadUrl: links.downloadUrl,
  };
};

const mapDropboxYear = (year) => {
  const folders = DROPBOX_BROCHURE_MANIFEST[year] || {};

  return Object.entries(folders).reduce((acc, [folderName, files]) => {
    const schoolSlug = resolveSchoolByFolder(folderName);

    if (!schoolSlug || !Array.isArray(files)) {
      return acc;
    }

    acc[schoolSlug] = files.map((file) => buildDropboxBrochure(schoolSlug, file.fileName, file.sharedUrl));
    return acc;
  }, {});
};

const dropboxCurrentYear = mapDropboxYear(CURRENT_YEAR);

const previousYearBrochures = {
  amersham: [],
  cardinal: [
    buildBrochure('September', 'Вересень', 'Cardinal', 'Cardinal', cardinal_september),
    buildBrochure('November', 'Листопад', 'Cardinal', 'Cardinal', cardinal_november),
  ],
  glasgow: [],
  guildford: [],
  hillingdon: [
    buildBrochure('November', 'Листопад', 'Hillingdon', 'Hillingdon', hillingdon_november),
  ],
  holland: [
    buildBrochure('September', 'Вересень', 'Holland Park', 'Holland Park', holland_september),
    buildBrochure('November', 'Листопад', 'Holland Park', 'Holland Park', holland_november),
  ],
  kingston: [
    buildBrochure('September', 'Вересень', 'Kingston', 'Kingston', kingston_september),
    buildBrochure('November', 'Листопад', 'Kingston', 'Kingston', kingston_november),
  ],
  merton: [],
  northampton: [],
  richmond: [
    buildBrochure('September', 'Вересень', 'Richmond', 'Richmond', richmond_september),
    buildBrochure('November', 'Листопад', 'Richmond', 'Richmond', richmond_november),
  ],
  stratford: [],
  tunbridge: [
    buildBrochure('September', 'Вересень', 'Tunbridge Wells', 'Tunbridge Wells', tunbridge_september),
    buildBrochure('November', 'Листопад', 'Tunbridge Wells', 'Tunbridge Wells', tunbridge_november),
  ],
  wilberforce: [
    buildBrochure('September', 'Вересень', 'Wilberforce', 'Wilberforce', wilberforce_september),
    buildBrochure('November', 'Листопад', 'Wilberforce', 'Wilberforce', wilberforce_november),
  ],
  woking: [
    buildBrochure('September', 'Вересень', 'Woking', 'Woking', woking_september),
    buildBrochure('November', 'Листопад', 'Woking', 'Woking', woking_november),
  ],
};

const createSchoolBrochureEntry = (schoolSlug) => ({
  [CURRENT_YEAR]: dropboxCurrentYear[schoolSlug] || [],
  [PREVIOUS_YEAR]: previousYearBrochures[schoolSlug] || [],
});

export const NEWSLETTERS = {
  amersham: createSchoolBrochureEntry('amersham'),
  cardinal: createSchoolBrochureEntry('cardinal'),
  glasgow: createSchoolBrochureEntry('glasgow'),
  guildford: createSchoolBrochureEntry('guildford'),
  hillingdon: createSchoolBrochureEntry('hillingdon'),
  holland: createSchoolBrochureEntry('holland'),
  kingston: createSchoolBrochureEntry('kingston'),
  merton: createSchoolBrochureEntry('merton'),
  northampton: createSchoolBrochureEntry('northampton'),
  nursery: {
    isNurseryNoticeOnly: true,
  },
  richmond: createSchoolBrochureEntry('richmond'),
  stratford: createSchoolBrochureEntry('stratford'),
  tunbridge: createSchoolBrochureEntry('tunbridge'),
  wilberforce: createSchoolBrochureEntry('wilberforce'),
  woking: createSchoolBrochureEntry('woking'),
};